import { render, staticRenderFns } from "./DetailsChatPDF.vue?vue&type=template&id=69bcafa4&scoped=true"
import script from "./DetailsChatPDF.vue?vue&type=script&lang=ts"
export * from "./DetailsChatPDF.vue?vue&type=script&lang=ts"
import style0 from "./DetailsChatPDF.vue?vue&type=style&index=0&id=69bcafa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bcafa4",
  null
  
)

export default component.exports